import {
  Box,
  Pagination,
  Select,
  TableCell,
  TableFooter,
  TableHead,
  TableRow,
  Table as TableUI,
  Typography,
} from '@astro-ui/components'
import { withPopupConfirmation } from 'components/PopupConfirmation'
import useTable from './useTable'
import Row from './Row'

const Table = () => {
  const { query, item, supplyOrderRequest, handleChangePage, handleChangeRowsPerPage } = useTable()

  return (
    <Box>
      <TableUI
        tableContainerProps={{
          sx: { borderRadius: 0, boxShadow: 'unset', borderTop: '1px solid #E9E9E9' },
        }}
        tableHeaders={[]}
        TableHeaderComponent={
          <TableHead>
            <TableRow sx={{ backgroundColor: '#FAFAFA' }}>
              <TableCell textAlign="center">
                <Typography variant="body-smallStrong" whiteSpace="nowrap">
                  No
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body-smallStrong" whiteSpace="nowrap">
                  Nama Produk
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body-smallStrong" whiteSpace="nowrap">
                  Nomor SKU
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body-smallStrong" whiteSpace="nowrap">
                  Expiry Date
                </Typography>
              </TableCell>
              <TableCell textAlign="center">
                <Typography variant="body-smallStrong" whiteSpace="nowrap">
                  Jumlah
                </Typography>
              </TableCell>
              <TableCell textAlign="center">
                <Typography variant="body-smallStrong" whiteSpace="nowrap">
                  UoM
                </Typography>
              </TableCell>
              <TableCell textAlign="center">
                <Typography variant="body-smallStrong" whiteSpace="nowrap">
                  Atur
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
        }
        TableFooterComponent={
          <TableFooter>
            <TableRow>
              <TableCell colSpan={13}>
                <Box display="flex" justifyContent="space-between">
                  <Box display="flex" gap="8px" alignItems="center">
                    <Select
                      required
                      options={['10', '20', '30', '50']}
                      value={String(query.pageSize)}
                      onChange={(val) => {
                        handleChangeRowsPerPage(Number(val))
                      }}
                    />
                    <Typography variant="body3" fontWeight={700}>
                      Tiap Halaman
                    </Typography>
                  </Box>
                  <Pagination
                    pageIndex={query?.pageIndex ? query.pageIndex + 1 : 1}
                    pageSize={query.pageSize || 10}
                    numberOfElements={item.length || 0}
                    onClick={handleChangePage}
                  />
                </Box>
              </TableCell>
            </TableRow>
          </TableFooter>
        }
      >
        {item.map((product) => (
          <Row
            key={product.supplyOrderProductDetailId}
            product={product}
            supplyOrderRequest={supplyOrderRequest}
          />
        ))}
      </TableUI>
    </Box>
  )
}

export default withPopupConfirmation(Table)
